import { forwardRef, useMemo } from 'react';

import clsx from 'clsx';

import { Image } from '../Image';

import { lineIcons } from './data';

type keys = 'button' | 'a';

type Elements = React.JSX.IntrinsicElements['a'] &
  React.JSX.IntrinsicElements['button'];

export interface LineButtonProps extends Elements {
  icon: keyof typeof lineIcons | SVGType | string;
  title: string;
  fallback?: string | SVGType;
  element?: keys;
}

const LineButton = forwardRef<
  HTMLAnchorElement | HTMLButtonElement,
  LineButtonProps
>(function LineButton(
  {
    icon,
    title,
    fallback,
    element, //: Element = 'button' as T,
    ...props
  },
  ref
) {
  const Element = element ?? 'button';
  const [IconLineCard, iconProps] = useMemo(() => {
    if (typeof icon !== 'string') return [icon, {}];
    return lineIcons?.[icon as 'global']
      ? [lineIcons?.[icon as 'global'], {}]
      : [Image, { src: icon, fallback }];
  }, [icon, fallback]);
  return (
    <Element
      // @ts-expect-error I don't have time to fix this
      ref={ref}
      {...props}
      className={clsx(
        `data-[state=on]:border-brand focus:ring-brand box-border flex items-center gap-2
        rounded border border-gray-200 px-6 py-2 focus:outline-none focus:ring-1
        data-[state=on]:shadow-[inset_16px_0px_0px_-8px_theme(colors.brand.DEFAULT)]`,
        props.className
      )}
    >
      <IconLineCard
        {...iconProps}
        className="dark:drop-shadow-dc aspect-square w-16 shrink-0 object-cover"
      />
      <span
        className="mx-auto whitespace-pre text-balance text-xl font-semibold capitalize
          text-gray-600 dark:text-gray-200"
      >
        {title}
      </span>
    </Element>
  );
});

LineButton.displayName = 'LineButton';

export { LineButton };
